import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.manual.storage');
import { OnInit, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ActivatedRoute, Router } from '@angular/router';

import { FlatTreeControl } from '@angular/cdk/tree';
import { FileNode, FileDataSource } from "src/libs/drive/file";
import { Chart, ChartConfiguration } from 'chart.js';
import 'chart.js/auto';



interface FileItem {
    id: string;
    name: string;
    type: 'file' | 'folder';
    size?: number;
    modifiedDate: string;
    parentId: string | null;
}

interface UploadProgress {
    fileName: string;
    progress: number;
}

@Component({
    selector: 'wiz-portal-gsdcadmin-manual-storage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.manual.storage/view.scss */
/* src/app/portal.gsdcadmin.manual.storage/view.scss: no such file or directory */`],
})
export class PortalGsdcadminManualStorageComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router    )         private router: Router    ) { }

    public session: any;
    public community: string = '';
    public isAdmin: boolean = false;
    public rootLabel: string = '루트';
    // ====== 파일 스토리지 상태 ======
    public files: FileItem[] = [];

    public currentFolderId: string | null = null;
    public selectedItems: Set<string> = new Set();
    public searchQuery: string = '';
    public renamingId: string | null = null;
    public renameValue: string = '';
    public uploadProgress: UploadProgress[] = [];
    public isDragging: boolean = false;

    public folderPath: Array<{ id: string | null; name: string }> = [];

    public isCreatingFolder: boolean = false;
    public newFolderName: string = '';

    // 트리 관련
    public rootNode: FileNode;
    public treeControl: FlatTreeControl<FileNode>;
    public dataSource: FileDataSource;
    public hasChild = (_: number, node: FileNode) => node.extended;

    // 모니터링
    public totalQuotaBytes = 0;
    public usedBytes = 0;
    public usedDisplay = '0 GB';
    public quotaDisplay = '제한 없음';

    private usageChart: Chart | null = null;

    // 검색 상태
    public isSearchMode = false;
    public searchResults: FileItem[] = [];

    // 행 선택 드래그 상태
    public isRangeSelecting: boolean = false;
    private dragStartIndex: number | null = null;
    private dragCurrentIndex: number | null = null;

    // 드래그 시작 시점의 선택 상태(이전 선택 유지용)
    private dragBaseSelection: Set<string> = new Set();

    // 클릭만 했는지, 드래그까지 했는지 구분용
    private hasDragged: boolean = false;

    // 클릭한 행 정보 (토글 판단용)
    private clickedIndex: number | null = null;
    private clickedItemId: string | null = null;
    private clickedWasSelected: boolean = false;

    // 항목 이동 드래그 상태
    public dragItemId: string | null = null;
    public dragItemSourceFolderId: string | null = null;
    public dragOverFolderId: string | null = null;
    public isBackRowDragOver: boolean = false;

    // 모니터링 스코프
    public usageScope: 'global' | 'community' = 'community';
    public usageCommunityName: string | null = null;

    @ViewChild('newFolderInput') newFolderInput?: ElementRef<HTMLInputElement>;

    // ====== 라이프사이클 ======
    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();
        this.session = this.service.auth.session;
        this.isAdmin = this.session?.role === 'admin';

        if (this.isAdmin) {
            this.community = '';
            this.rootLabel = '스토리지';
        } else {
            this.community = this.session?.job_title || '';
            this.rootLabel = this.community || '루트';
        }

        this.folderPath = [
            { id: null, name: this.rootLabel }
        ];

        this.rootNode = new FileNode(this.rootLabel, '', 'folder');

        this.treeControl = new FlatTreeControl<FileNode>(
            (node: FileNode) => node.level,
            (node: FileNode) => node.extended
        );
        this.dataSource = new FileDataSource(this);

        await this.loadCurrentFolder();
        await this.service.render();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        // 필요 시 확장
    }

    public ngAfterViewInit(): void {
    }

    public ngOnDestroy(): void {
        if (this.usageChart) {
            this.usageChart.destroy();
            this.usageChart = null;
        }
    }

    private async loadCurrentFolder(): Promise<void> {
        const path = this.currentFolderId || '';

        const { code, data } = await wiz.call("list", {
            community: this.community,
            path
        });

        if (code === 200 && data && Array.isArray(data.items)) {
            this.files = data.items;
        } else {
            this.files = [];
        }
    }

    // ====== 계산 프로퍼티 ======
    public get currentFiles(): FileItem[] {
        // 이제는 "현재 폴더에 있는 실제 목록"만 의미함 (검색 필터 없음)
        return this.files;
    }

    public get displayFiles(): FileItem[] {
        return this.isSearchMode ? this.searchResults : this.files;
    }

    // ====== 유틸 ======
    public formatFileSize(bytes?: number): string {
        if (!bytes) return '-';
        const kb = bytes / 1024;
        const mb = kb / 1024;
        const gb = mb / 1024;

        if (gb >= 1) return `${gb.toFixed(2)} GB`;
        if (mb >= 1) return `${mb.toFixed(2)} MB`;
        if (kb >= 1) return `${kb.toFixed(2)} KB`;
        return `${bytes} B`;
    }

    public get usageTitle(): string {
        if (this.isAdmin) {
            if (this.usageScope === 'global') {
                return '전체 스토리지 모니터링';
            }

            const name =
                this.usageCommunityName ||
                (this.currentFolderId || '').split('/')[0] ||
                this.community ||
                '';

            if (name) {
                return `${name} 스토리지 모니터링`;
            }
            return '스토리지 모니터링';
        }

        const communityName = this.community || '';
        if (communityName) {
            return `${communityName} 스토리지 모니터링`;
        }
        return '스토리지 모니터링';
    }

    // 공통 갱신 (수정/삭제 후 화면 갱신)
    private async refreshAfterMutation(): Promise<void> {
        if (this.isSearchMode && this.searchQuery.trim()) {
            await this.handleSearch();
        } else {
            await this.loadCurrentFolder();
        }
        await this.service.render();
    }

    // ====== 트리 유틸 ======
    private findNodeByPath(path: string | null): FileNode | null {
        if (!this.treeControl || !path) return null;
        const nodes = this.treeControl.dataNodes || [];
        return nodes.find(n => n.path === path) || null;
    }

    // ====== 업로드 / 드래그 앤 드롭 ======
    private isFileDrag(event: DragEvent): boolean {
        const dt = event.dataTransfer;
        if (!dt) return false;

        const items = dt.items;
        if (items && items.length > 0) {
            for (let i = 0; i < items.length; i++) {
                const it = items[i];
                if (it.kind === 'file') {
                    return true;
                }
            }
        }

        if (dt.files && dt.files.length > 0) {
            return true;
        }

        return false;
    }
    public async handleFileUpload(fileList: FileList | null): Promise<void> {
        if (this.isSearchMode) {
            await this.service.alert.error(
                '검색 모드에서는 파일 업로드를 할 수 없습니다.\n검색을 해제한 후 다시 시도해 주세요.'
            );
            return;
        }
        if (!fileList || fileList.length === 0) return;

        const filesArray = Array.from(fileList);

        // 이미지 파일만 허용 (type이 image/* 인 것만)
        const imageFiles = filesArray.filter(f => (f.type || '').startsWith('image/'));

        if (imageFiles.length !== filesArray.length) {
            const rejected = filesArray
                .filter(f => !(f.type || '').startsWith('image/'))
                .map(f => f.name);
            
            return await this.service.alert.warning("이미지 파일만 업로드할 수 있습니다.");
        }

        if (this.totalQuotaBytes > 0) {
            const uploadBytes = filesArray.reduce((sum, f) => sum + (f.size || 0), 0);
            const remainingBytes = this.totalQuotaBytes - this.usedBytes;

            if (uploadBytes > remainingBytes) {
                await this.service.alert.error(
                    `저장공간이 부족합니다.\n` +
                    `필요 용량: ${this.formatBytes(uploadBytes)}\n` +
                    `남은 용량: ${this.formatBytes(Math.max(remainingBytes, 0))}\n` +
                    `총 용량: ${this.quotaDisplay}`
                );
                return;
            }
        }

        const existingNames = new Set(this.files.map(f => f.name));
        const conflictNames = filesArray
            .map(f => f.name)
            .filter(name => existingNames.has(name));

        if (conflictNames.length > 0) {
            const msg = conflictNames.length === 1
                ? `이미 현재 위치에 같은 이름의 파일이 있습니다: ${conflictNames[0]}`
                : `이미 현재 위치에 같은 이름의 파일이 있습니다: ${conflictNames.join(', ')}`;
            await this.service.alert.error(msg);
            return;
        }

        const fd = new FormData();
        // console.log("filesArray : ", filesArray[0])
        // console.log("current : ", this.currentFolderId)
        // fd.append('upload', filesArray[0])
        fd.append('community', this.community);
        fd.append('path', this.currentFolderId || '');

        // 추가
        // let fdurl = `/image/upload/${this.community}${this.currentFolderId ? '/' + this.currentFolderId : ''}`;
        // for (const file of filesArray)
        // const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });

        filesArray.forEach(file => {
            fd.append('file[]', file);
        });

        const uploadItems = filesArray.map(f => ({
            name: f.name,
            size: f.size || 0
        }));

        try {
            const url = wiz.url('upload');
            const { code, data } = await this.uploadWithProgress(url, fd, uploadItems);

            if (code === 413) {
                await this.service.alert.error(
                    typeof data === 'string'
                        ? data
                        : '저장공간이 부족하여 업로드할 수 없습니다.'
                );
                return;
            }

            if (code === 409) {
                await this.service.alert.error(
                    typeof data === 'string' ? data : '이미 존재하는 이름의 파일이 있습니다.'
                );
                return;
            }

            if (code !== 200) {
                console.error('upload error', code, data);
                await this.service.alert.error('업로드에 실패했습니다.');
                return;
            }

            // await this.service.alert.success('업로드가 완료되었습니다.');
            await this.service.render();
            await this.refreshAfterMutation();
        } catch (e: any) {
            console.error('upload exception', e);
            await this.service.alert.error('업로드 중 오류가 발생했습니다.');
        }
    }

    public async handleFileInputChange(event: Event): Promise<void> {
        const input = event.target as HTMLInputElement;
        const files = input.files;

        await this.handleFileUpload(files);

        if (input) {
            input.value = '';
        }
    }

    // 폴더(또는 여러 파일 + 상대경로)를 서버에 업로드하는 공통 함수
    private async uploadFolderEntriesToServer(
        entries: Array<{ file: File; relPath: string }>
    ): Promise<void> {
        if (this.isSearchMode) {
            await this.service.alert.error(
                '검색 모드에서는 폴더 업로드를 할 수 없습니다.\n검색을 해제한 후 다시 시도해 주세요.'
            );
            return;
        }
        if (!entries || entries.length === 0) return;

        if (this.totalQuotaBytes > 0) {
            const uploadBytes = entries.reduce((sum, e) => sum + (e.file.size || 0), 0);
            const remainingBytes = this.totalQuotaBytes - this.usedBytes;

            if (uploadBytes > remainingBytes) {
                await this.service.alert.error(
                    `저장공간이 부족합니다.\n` +
                    `필요 용량: ${this.formatBytes(uploadBytes)}\n` +
                    `남은 용량: ${this.formatBytes(Math.max(remainingBytes, 0))}\n` +
                    `총 용량: ${this.quotaDisplay}`
                );
                return;
            }
        }

        // 1) 업로드되는 항목들에서 "최상위 폴더 이름"만 추출
        const folderNameSet = new Set<string>();
        for (const e of entries) {
            const rel = e.relPath || e.file.name;
            const parts = rel.split('/').filter(Boolean);
            if (parts.length >= 1) {
                folderNameSet.add(parts[0]);
            }
        }

        // 2) 현재 위치에 이미 존재하는 같은 이름의 폴더가 있는지 선제 검사
        const existingFolderNames = new Set(
            this.files.filter(f => f.type === 'folder').map(f => f.name)
        );

        const conflictRoots = Array.from(folderNameSet).filter(name =>
            existingFolderNames.has(name)
        );

        if (conflictRoots.length > 0) {
            const msg = conflictRoots.length === 1
                ? `이미 현재 위치에 같은 이름의 폴더가 있습니다: ${conflictRoots[0]}`
                : `이미 현재 위치에 같은 이름의 폴더가 있습니다: ${conflictRoots.join(', ')}`;
            await this.service.alert.error(msg);
            return;
        }

        // 3) 실제 업로드 준비
        const fd = new FormData();
        fd.append('community', this.community);
        fd.append('base_path', this.currentFolderId || '');

        const relList: string[] = [];

        for (const e of entries) {
            fd.append('file[]', e.file);
            relList.push(e.relPath || e.file.name);
        }

        fd.append('rel_list', JSON.stringify(relList));

        const url = wiz.url('upload_tree');

        // 4) 진행률 표시용 데이터: "최상위 폴더 이름 + 해당 폴더 아래 파일들의 전체 size 합"
        const folderSizeMap = new Map<string, number>();

        for (const e of entries) {
            const rel = e.relPath || e.file.name;
            const parts = rel.split('/').filter(Boolean);
            const rootName = parts.length >= 1 ? parts[0] : e.file.name;

            const prev = folderSizeMap.get(rootName) || 0;
            folderSizeMap.set(rootName, prev + (e.file.size || 0));
        }

        const uploadItems = Array.from(folderSizeMap.entries()).map(([name, size]) => ({
            name,
            size
        }));

        try {
            const { code, data } = await this.uploadWithProgress(url, fd, uploadItems);

            if (code === 413) {
                await this.service.alert.error(
                    typeof data === 'string'
                        ? data
                        : '저장공간이 부족하여 업로드할 수 없습니다.'
                );
                return;
            }

            if (code === 409) {
                await this.service.alert.error(
                    typeof data === 'string' ? data : '이미 존재하는 이름의 파일/폴더가 있습니다.'
                );
                return;
            }

            if (code !== 200) {
                console.error('folder upload error', code, data);
                await this.service.alert.error('폴더 업로드에 실패했습니다.');
                return;
            }

            await this.loadCurrentFolder();
            await this.refreshTreeForCurrentFolder();
            // await this.service.alert.success('폴더 업로드가 완료되었습니다.');
            await this.service.render();
            this.renderUsageChart();
        } catch (e: any) {
            console.error('folder upload exception', e);
            await this.service.alert.error('폴더 업로드 중 오류가 발생했습니다.');
        }
    }

    public async handleFolderUpload(event: Event): Promise<void> {
        const input = event.target as HTMLInputElement;
        if (!input) return;

        if (this.isSearchMode) {
            input.value = '';
            await this.service.alert.error(
                '검색 모드에서는 폴더 업로드를 할 수 없습니다.\n검색을 해제한 후 다시 시도해 주세요.'
            );
            return;
        }
        const files = input.files;
        if (!files || files.length === 0) {
            input.value = '';
            return;
        }

        const entries: Array<{ file: File; relPath: string }> = [];

        Array.from(files).forEach(file => {
            const rel =
                (file as any).webkitRelativePath ||
                file.name;

            entries.push({ file, relPath: rel });
        });

        await this.uploadFolderEntriesToServer(entries);
        input.value = '';
    }

    public async handleDragOver(event: DragEvent): Promise<void> {
        if (this.dragItemId) return;
        if (!this.isFileDrag(event)) return;

        const dt = event.dataTransfer;
        if (!dt) return;

        event.preventDefault();
        if (this.isSearchMode) {
            return;
        }
        if (!this.isDragging) {
            this.isDragging = true;
            await this.service.render();
        }
    }

    public async handleDragLeave(event: DragEvent): Promise<void> {
        if (this.dragItemId) return;
        if (!this.isFileDrag(event)) return;

        event.preventDefault();

        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        const { clientX, clientY } = event;

        const outside =
            clientX < rect.left ||
            clientX > rect.right ||
            clientY < rect.top ||
            clientY > rect.bottom;

        if (outside && this.isDragging) {
            this.isDragging = false;
            await this.service.render();
        }
    }

    public async handleDragEnd(event: DragEvent): Promise<void> {
        if (this.dragItemId) return;
        if (!this.isFileDrag(event)) return;

        if (this.isDragging) {
            this.isDragging = false;
            await this.service.render();
        }
    }

    private handleDirectoryDrop(entries: any[]): void {
        const collectedEntries: Array<{ file: File; relPath: string }> = [];
        let pending = 0;

        const done = () => {
            if (pending === 0 && collectedEntries.length > 0) {
                this.uploadFolderEntriesToServer(collectedEntries);
            }
        };

        const traverseEntry = (entry: any, path: string) => {
            if (entry.isFile) {
                pending++;
                (entry as any).file((file: File) => {
                    const relPath = path + file.name;
                    collectedEntries.push({ file, relPath });
                    pending--;
                    done();
                });
            } else if (entry.isDirectory) {
                const dirReader = entry.createReader();
                pending++;
                dirReader.readEntries((childEntries: any[]) => {
                    childEntries.forEach((ent: any) => {
                        traverseEntry(ent, path + entry.name + '/');
                    });
                    pending--;
                    done();
                });
            }
        };

        entries.forEach(entry => traverseEntry(entry, ''));
    }

    public async handleDrop(event: DragEvent): Promise<void> {
        // 내부 아이템 이동 드롭이면 업로드 로직 아예 타지 않게
        if (this.dragItemId) return;
        if (!this.isFileDrag(event)) return;

        const dt = event.dataTransfer;
        if (!dt) return;

        event.preventDefault();
        this.isDragging = false;
        await this.service.render();

        if (this.isSearchMode) {
            await this.service.alert.error(
                '검색 모드에서는 드래그 앤 드롭 업로드를 할 수 없습니다.\n검색을 해제한 후 다시 시도해 주세요.'
            );
            return;
        }

        const items = dt.items;

        if (items && items.length > 0 && (items[0] as any).webkitGetAsEntry) {
            const entries: any[] = [];
            for (let i = 0; i < items.length; i++) {
                const entry = (items[i] as any).webkitGetAsEntry();
                if (entry) entries.push(entry);
            }
            this.handleDirectoryDrop(entries);
        } else {
            const files = dt.files || null;
            this.handleFileUpload(files);
        }
    }

    // ====== 폴더 생성 ======
    public async handleCreateFolder(): void {
        if (this.isSearchMode) {
            await this.service.alert.error(
                '검색 모드에서는 폴더를 생성할 수 없습니다.\n검색을 해제한 후 다시 시도해 주세요.'
            );
            return;
        }
        this.isCreatingFolder = true;
        this.newFolderName = '';

        await this.service.render();

        setTimeout(() => {
            this.newFolderInput?.nativeElement?.focus();
        }, 0);
    }

    public async confirmCreateFolder(): Promise<void> {
        if (this.isSearchMode) {
            await this.service.alert.error(
                '검색 모드에서는 폴더를 생성할 수 없습니다.\n검색을 해제한 후 다시 시도해 주세요.'
            );
            return;
        }

        const name = this.newFolderName.trim();
        if (!name) {
            await this.service.alert.error("폴더 이름을 입력하세요.");
            return;
        }

        const { code, data } = await wiz.call("mkdir", {
            community: this.community,
            parent: this.currentFolderId || "",
            name
        });

        if (code === 409) {
            await this.service.alert.error(
                typeof data === 'string' ? data : "같은 이름의 폴더가 이미 존재합니다."
            );
            return;
        }

        this.isCreatingFolder = false;
        this.newFolderName = '';

        if (code !== 200) {
            await this.service.alert.error("폴더 생성에 실패했습니다.");
            return;
        }

        await this.loadCurrentFolder();
        await this.refreshTreeForCurrentFolder();
        // await this.service.alert.success("폴더가 생성되었습니다.");
        await this.service.render();
        this.renderUsageChart();
    }

    public async cancelCreateFolder(): void {
        this.isCreatingFolder = false;
        this.newFolderName = '';

        await this.service.render();
    }

    // ====== 삭제 ======
    public async handleDelete(): Promise<void> {
        if (this.selectedItems.size === 0) return;
        const ok = await this.service.alert.warning(
            `${this.selectedItems.size}개 항목을 삭제하시겠습니까?`,
            '취소',
            '삭제'
        );
        if (!ok) return;

        const paths = Array.from(this.selectedItems);

        for (const path of paths) {
            const { code } = await wiz.call("delete", {
                community: this.community,
                path,
            });

            if (code !== 200) {
                console.error('delete failed for', path, code);
            }
        }

        this.selectedItems = new Set();
        await this.refreshAfterMutation();
        // await this.service.alert.success("선택한 항목이 삭제되었습니다.");
    }

    public async handleDeleteSingle(item: FileItem): Promise<void> {
        const ok = await this.service.alert.warning(
            `"${item.name}"을(를) 삭제하시겠습니까?`,
            '취소',
            '삭제'
        );

        if (!ok) return;

        const { code, data } = await wiz.call("delete", {
            community: this.community,
            path: item.id,
        });

        if (code !== 200) {
            await this.service.alert.error("삭제에 실패했습니다.");
            return;
        }

        await this.refreshAfterMutation();
        // await this.service.alert.success("삭제가 완료되었습니다.");
    }

    // ====== 다운로드 ======
    public handleDownload(item: FileItem): void {
        const base = wiz.url("download");
        const url =
            `${base}?community=${encodeURIComponent(this.community)}` +
            `&path=${encodeURIComponent(item.id)}`;

        window.open(url, "_blank");
    }

    public handleDownloadSelected(): void {
        if (this.selectedItems.size === 0) return;

        const paths = Array.from(this.selectedItems);

        const base = wiz.url("download");
        const url =
            `${base}?community=${encodeURIComponent(this.community)}` +
            `&paths=${encodeURIComponent(JSON.stringify(paths))}`;

        window.open(url, "_blank");
    }

    // ====== 이름 변경 ======
    public async handleRename(item: FileItem): void {
        this.renamingId = item.id;
        this.renameValue = item.name;

        await this.service.render();
    }

    public async confirmRename(): Promise<void> {
        if (!this.renamingId) return;

        const newName = this.renameValue.trim();
        if (!newName) {
            await this.service.alert.error('이름을 비울 수 없습니다.');
            return;
        }

        const original = this.files.find(f => f.id === this.renamingId);
        if (original && original.name === newName) {
            this.renamingId = null;
            this.renameValue = '';
            await this.service.render();
            return;
        }

        const { code, data } = await wiz.call("rename", {
            community: this.community,
            path: this.renamingId,
            new_name: newName
        });

        if (code === 409) {
            await this.service.alert.error(
                typeof data === 'string' ? data : "같은 이름의 항목이 이미 존재합니다."
            );
            return;
        }

        this.renamingId = null;
        this.renameValue = '';

        if (code !== 200) {
            await this.service.alert.error("이름 변경에 실패했습니다.");
            return;
        }


        await this.refreshAfterMutation();
        // await this.service.alert.success("이름이 변경되었습니다.");
    }

    public async cancelRename(): void {
        this.renamingId = null;
        this.renameValue = '';

        await this.service.render();
    }

    // ====== 선택 ======
    public async toggleSelect(id: string): void {
        const newSelected = new Set(this.selectedItems);
        if (newSelected.has(id)) newSelected.delete(id);
        else newSelected.add(id);
        this.selectedItems = newSelected;

        await this.service.render();
    }

    public async toggleSelectAll(): Promise<void> {
        if (this.selectedItems.size === this.displayFiles.length) {
            this.selectedItems = new Set();
        } else {
            this.selectedItems = new Set(this.displayFiles.map(f => f.id));
        }
        await this.service.render();
    }

    // ====== 폴더 이동 ======
    public async openFolder(folder: FileItem): void {
        if (folder.type === 'folder') {
            this.currentFolderId = folder.id;
            this.folderPath = [
                ...this.folderPath,
                { id: folder.id, name: folder.name }
            ];
            this.selectedItems = new Set();

            await this.loadCurrentFolder();
            await this.refreshTreeForCurrentFolder();
            await this.service.render();
        }
    }

    public async navigateToFolder(folderId: string | null, index: number): Promise<void> {
        this.currentFolderId = folderId;
        this.folderPath = this.folderPath.slice(0, index + 1);
        this.selectedItems = new Set();

        await this.loadCurrentFolder();
        await this.refreshTreeForCurrentFolder();
        await this.service.render();
    }

    // ====== 업로드 진행률 ======
    private uploadWithProgress(
        url: string,
        formData: FormData,
        items: { name: string; size: number }[]
    ): Promise<{ code: number; data: any }> {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            // === 1) 진행률 객체 초기화 ===
            const existingNames = new Set(this.uploadProgress.map(p => p.fileName));
            const newItems: UploadProgress[] = [];

            for (const item of items) {
                if (!existingNames.has(item.name)) {
                    newItems.push({ fileName: item.name, progress: 0 });
                }
            }

            if (newItems.length > 0) {
                this.uploadProgress = [...this.uploadProgress, ...newItems];
                this.service.render();
            }

            // === 2) 파일/폴더별 바이트 구간 계산 ===
            const ranges: { name: string; start: number; end: number }[] = [];
            let acc = 0;
            for (const item of items) {
                const start = acc;
                acc += item.size;
                const end = acc;
                ranges.push({ name: item.name, start, end });
            }
            const totalBytes = acc || 1;

            xhr.upload.onprogress = (event: ProgressEvent) => {
                if (!event.lengthComputable) return;

                const loaded = event.loaded;

                this.uploadProgress = this.uploadProgress.map(p => {
                    const r = ranges.find(r => r.name === p.fileName);
                    if (!r) return p;

                    const span = r.end - r.start || 1;
                    const localLoaded = Math.min(
                        Math.max(loaded - r.start, 0),
                        span
                    );
                    const percent = Math.round((localLoaded / span) * 100);

                    return { ...p, progress: Math.max(0, Math.min(percent, 100)) };
                });

                this.service.render();
            };

            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    try {
                        const res = JSON.parse(xhr.responseText || '{}');
                        const nameSet = new Set(items.map(i => i.name));
                        this.uploadProgress = this.uploadProgress.map(p => {
                            if (nameSet.has(p.fileName)) {
                                return { ...p, progress: 100 };
                            }
                            return p;
                        });
                        this.service.render();

                        setTimeout(() => {
                            this.uploadProgress = this.uploadProgress.filter(
                                p => !nameSet.has(p.fileName)
                            );
                            this.service.render();
                        }, 800);

                        resolve(res);
                    } catch (e) {
                        reject(e);
                    }
                }
            };

            xhr.onerror = () => {
                reject(new Error('Upload failed'));
            };

            xhr.open('POST', url, true);
            xhr.withCredentials = true;
            xhr.send(formData);
        });
    }

    public async list(node: FileNode): Promise<FileNode[]> {
        const path = node.path || '';
        const { code, data } = await wiz.call("list", {
            community: this.community,
            path
        });
        if (code !== 200 || !data || !Array.isArray(data.items))
            return [];

        const folders = data.items.filter((item: any) => item.type === 'folder');

        return folders.map((item: any) =>
            new FileNode(
                item.name,
                item.id,
                'folder',
                node,
                node.level + 1
            )
        );
    }

    // 폴더 클릭 시 현재 폴더 이동
    public async openFolderFromTree(node: FileNode): Promise<void> {
        if (!node) return;

        if (this.isSearchMode) {
            this.isSearchMode = false;
            this.searchQuery = '';
            this.searchResults = [];
        }

        this.selectedItems = new Set();
        this.isRangeSelecting = false;
        this.hasDragged = false;
        this.dragStartIndex = null;
        this.dragCurrentIndex = null;
        this.dragBaseSelection = new Set();
        this.clickedIndex = null;
        this.clickedItemId = null;
        this.clickedWasSelected = false;

        if (node.extended === true) {
            await this.dataSource.toggle(node, false);
        } else {
            await this.dataSource.toggle(node, true);
        }

        this.currentFolderId = node.path || '';

        const segments = (this.currentFolderId || '').split('/').filter(Boolean);
        this.folderPath = [{ id: null, name: this.rootLabel }];
        let accum = '';
        for (const seg of segments) {
            accum = accum ? `${accum}/${seg}` : seg;
            this.folderPath.push({ id: accum, name: seg });
        }

        await this.loadCurrentFolder();
        await this.service.render();
    }

    private async refreshTreeForCurrentFolder(): Promise<void> {
        const path = this.currentFolderId || '';

        // 루트(커뮤니티 루트)인 경우: 그냥 전체 다시 로드
        if (!path) {
            const children = await this.list(this.rootNode);
            this.dataSource.data = children;
            return;
        }

        // 현재 폴더에 해당하는 노드를 찾아서 그 부분만 리프레시
        const node = this.findNodeByPath(path);

        if (node) {
            // 이 노드를 한 번 닫았다가 다시 열어서 children 재조회
            await this.dataSource.toggle(node, false);
            await this.dataSource.toggle(node, true);
        } else {
            // 혹시 아직 트리에 안 올라와 있으면 전체 다시 만들고,
            // 필요한 경로를 따라가며 열어 준다.
            const children = await this.list(this.rootNode);
            this.dataSource.data = children;

            const segments = path.split('/').filter(Boolean);
            let accum = '';
            for (const seg of segments) {
                accum = accum ? `${accum}/${seg}` : seg;
                const n = this.findNodeByPath(accum);
                if (n && !n.extended) {
                    await this.dataSource.toggle(n, true);
                }
            }
        }
    }

    // ===== 검색 =====
    // 검색 실행 (Enter)
    public async handleSearch(): Promise<void> {
        const term = (this.searchQuery || '').trim();

        if (!term) {
            this.isSearchMode = false;
            this.searchResults = [];
            await this.loadCurrentFolder();
            await this.service.render();
            return;
        }

        const { code, data } = await wiz.call("search", {
            community: this.community,
            q: term,
            path: this.currentFolderId || ''
        });

        if (code === 200 && data && Array.isArray(data.items)) {
            this.searchResults = data.items;
            this.isSearchMode = true;
        } else {
            this.searchResults = [];
            this.isSearchMode = true;
        }

        this.selectedItems = new Set();
        await this.service.render();
    }

    // 검색 초기화 (X 버튼)
    public async clearSearch(): Promise<void> {
        this.searchQuery = '';
        this.isSearchMode = false;
        this.searchResults = [];
        this.selectedItems = new Set();

        await this.loadCurrentFolder();
        await this.service.render();
    }

    public async openFromSearch(item: FileItem): Promise<void> {
        if (item.type !== 'folder') return;

        this.isSearchMode = false;
        this.searchResults = [];
        this.searchQuery = '';

        this.currentFolderId = item.id;

        const segments = (this.currentFolderId || '').split('/').filter(Boolean);
        this.folderPath = [{ id: null, name: this.rootLabel }];
        let accum = '';
        for (const seg of segments) {
            accum = accum ? `${accum}/${seg}` : seg;
            this.folderPath.push({ id: accum, name: seg });
        }

        this.selectedItems = new Set();
        await this.loadCurrentFolder();
        await this.refreshTreeForCurrentFolder();
        await this.service.render();
    }

    // ===== 클릭/드래그 선택 =====
    private isInteractiveElement(target: EventTarget | null): boolean {
        let el = target as HTMLElement | null;
        while (el) {
            const tag = el.tagName;
            if (tag === 'INPUT' || tag === 'BUTTON' || tag === 'LABEL' || tag === 'A') {
                return true;
            }
            if (el.hasAttribute && el.hasAttribute('data-no-row-select')) {
                return true;
            }
            el = el.parentElement;
        }
        return false;
    }

    public async onRowMouseDown(event: MouseEvent, item: FileItem, index: number): Promise<void> {
        if (event.button !== 0) return;
        if (this.isInteractiveElement(event.target)) return;

        this.isRangeSelecting = true;
        this.hasDragged = false;

        this.dragStartIndex = index;
        this.dragCurrentIndex = index;

        this.dragBaseSelection = new Set(this.selectedItems);

        this.clickedIndex = index;
        this.clickedItemId = item.id;
        this.clickedWasSelected = this.selectedItems.has(item.id);

        this.updateSelectionRange();
        await this.service.render();
    }

    public async onRowMouseEnter(event: MouseEvent, item: FileItem, index: number): Promise<void> {
        if (!this.isRangeSelecting) return;
        if (this.dragCurrentIndex === index) return;

        this.hasDragged = true;
        this.dragCurrentIndex = index;

        this.updateSelectionRange();
        await this.service.render();
    }

    public onListMouseUp(): void {
        if (!this.isRangeSelecting) return;

        if (this.hasDragged) {
            this.isRangeSelecting = false;
            this.dragStartIndex = null;
            this.dragCurrentIndex = null;
            this.clickedIndex = null;
            this.clickedItemId = null;
            this.clickedWasSelected = false;
            this.service.render();
            return;
        }

        if (this.clickedIndex != null && this.clickedItemId) {
            const newSelected = new Set(this.dragBaseSelection);

            if (this.clickedWasSelected) {
                newSelected.delete(this.clickedItemId);
            } else {
                newSelected.add(this.clickedItemId);
            }

            this.selectedItems = newSelected;
        }

        this.isRangeSelecting = false;
        this.dragStartIndex = null;
        this.dragCurrentIndex = null;
        this.clickedIndex = null;
        this.clickedItemId = null;
        this.clickedWasSelected = false;

        this.service.render();
    }

    private updateSelectionRange(): void {
        if (this.dragStartIndex == null || this.dragCurrentIndex == null) return;

        const start = Math.min(this.dragStartIndex, this.dragCurrentIndex);
        const end = Math.max(this.dragStartIndex, this.dragCurrentIndex);

        const items = this.displayFiles;
        const newSelected = new Set<string>(this.dragBaseSelection);

        const rangeIds: string[] = [];
        for (let i = start; i <= end && i < items.length; i++) {
            rangeIds.push(items[i].id);
        }

        for (const id of rangeIds) {
            if (newSelected.has(id)) {
                newSelected.delete(id);
            } else {
                newSelected.add(id);
            }
        }
        this.selectedItems = newSelected;
    }

    // ===== 뒤로가기 =====
    public async goParentFolder(): Promise<void> {
        if (!this.currentFolderId) return;

        const segments = this.currentFolderId.split("/").filter(Boolean);
        segments.pop();

        const parentId = segments.length > 0 ? segments.join("/") : null;
        this.currentFolderId = parentId;

        this.folderPath = [{ id: null, name: this.rootLabel }];
        let accum = '';
        for (const seg of segments) {
            accum = accum ? `${accum}/${seg}` : seg;
            this.folderPath.push({ id: accum, name: seg });
        }

        this.resetSelectionState?.();
        this.selectedItems = new Set();

        await this.loadCurrentFolder();
        await this.refreshTreeForCurrentFolder();
        await this.service.render();
    }

    // ===== 폴더/파일 클릭 =====
    public async handleItemClick(item: FileItem): Promise<void> {
        if (this.isSearchMode) {
            if (item.type === 'folder') {
                await this.openFromSearch(item);
            } else {
                this.handleDownload(item);
            }
            return;
        }

        if (item.type === 'folder') {
            await this.openFolder(item);
        } else {
            this.handleDownload(item);
        }
    }

    // ===== 폴더/파일 이동 =====
    public onItemDragStart(event: DragEvent, item: FileItem): void {
        if (!this.canDragMoveItems) return;
        if (!event.dataTransfer) return;

        this.isRangeSelecting = false;

        this.dragItemId = item.id;
        this.dragItemSourceFolderId = this.currentFolderId;

        this.dragOverFolderId = null;
        this.isBackRowDragOver = false;

        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('application/x-storage-item', item.id);
    }
    public onItemDragEnd(event: DragEvent): void {
        this.dragItemId = null;
        this.dragItemSourceFolderId = null;

        this.dragOverFolderId = null;
        this.isBackRowDragOver = false;
    }
    public onItemDragOverFolder(event: DragEvent, target: FileItem): void {
        if (!this.canDragMoveItems) return;
        if (!event.dataTransfer) return;
        if (target.type !== 'folder') return;

        const types = Array.from(event.dataTransfer.types || []);
        if (!types.includes('application/x-storage-item')) return;

        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.dropEffect = 'move';

        // 상태가 바뀔 때만 렌더
        if (this.dragOverFolderId !== target.id) {
            this.dragOverFolderId = target.id;
            this.isBackRowDragOver = false;
            this.service.render();   // ★ 여기 추가
        }
    }

    public onItemDragLeaveFolder(event: DragEvent, target: FileItem): void {
        if (!this.canDragMoveItems) return;
        if (!event.dataTransfer) return;
        if (target.type !== 'folder') return;

        const types = Array.from(event.dataTransfer.types || []);
        if (!types.includes('application/x-storage-item')) return;

        if (this.dragOverFolderId === target.id) {
            this.dragOverFolderId = null;
            this.service.render();   // ★ 여기 추가
        }
    }



    public async onItemDropOnFolder(event: DragEvent, target: FileItem): Promise<void> {
        if (!this.canDragMoveItems) return;
        if (!event.dataTransfer) return;
        if (target.type !== 'folder') return;

        const types = Array.from(event.dataTransfer.types || []);
        if (!types.includes('application/x-storage-item')) return;

        event.preventDefault();
        event.stopPropagation();

        const srcId = event.dataTransfer.getData('application/x-storage-item') || this.dragItemId;
        if (!srcId) return;

        if (srcId === target.id || target.id.startsWith(srcId + '/')) {
            await this.service.alert.error('폴더를 자기 자신이나 하위 폴더로 이동할 수 없습니다.');
            return;
        }

        const { code, data } = await wiz.call("move", {
            community: this.community,
            src: srcId,
            dst: target.id
        });

        this.dragOverFolderId = null;
        this.isBackRowDragOver = false;

        if (code !== 200) {
            const msg = typeof data === 'string' ? data : '이동에 실패했습니다.';
            await this.service.alert.error(msg);
            return;
        }

        await this.loadCurrentFolder();
        await this.refreshTreeForCurrentFolder();

        if (this.isSearchMode) {
            await this.handleSearch();
        }

        this.selectedItems = new Set();
        await this.service.render();
    }

    // ===== 상위 폴더 행 드롭 =====
    public onBackRowDragOver(event: DragEvent): void {
        if (!this.canDragMoveItems) return;
        if (!event.dataTransfer) return;

        const types = Array.from(event.dataTransfer.types || []);
        if (!types.includes('application/x-storage-item')) return;

        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.dropEffect = 'move';

        if (!this.isBackRowDragOver) {
            this.isBackRowDragOver = true;
            this.dragOverFolderId = null;
            this.service.render();   // ★ 추가
        }
    }

    public onBackRowDragLeave(event: DragEvent): void {
        if (!this.canDragMoveItems) return;
        if (!event.dataTransfer) return;

        const types = Array.from(event.dataTransfer.types || []);
        if (!types.includes('application/x-storage-item')) return;

        if (this.isBackRowDragOver) {
            this.isBackRowDragOver = false;
            this.service.render();   // ★ 추가
        }
    }


    public async onBackRowDrop(event: DragEvent): Promise<void> {
        if (!this.canDragMoveItems) return;
        if (!event.dataTransfer) return;

        const types = Array.from(event.dataTransfer.types || []);
        if (!types.includes('application/x-storage-item')) return;

        event.preventDefault();
        event.stopPropagation();

        const srcId = event.dataTransfer.getData('application/x-storage-item') || this.dragItemId;
        if (!srcId) return;

        if (!this.currentFolderId) return;

        const segments = this.currentFolderId.split('/').filter(Boolean);
        if (segments.length === 0) return;

        segments.pop();
        const parentId = segments.length > 0 ? segments.join('/') : null;
        const dstId = parentId || '';
        if (srcId === dstId || dstId.startsWith(srcId + '/')) {
            await this.service.alert.error('폴더를 자기 자신이나 하위 폴더로 이동할 수 없습니다.');
            return;
        }

        const { code, data } = await wiz.call("move", {
            community: this.community,
            src: srcId,
            dst: dstId
        });

        this.isBackRowDragOver = false;
        this.dragOverFolderId = null;

        if (code !== 200) {
            const msg = typeof data === 'string' ? data : '이동에 실패했습니다.';
            await this.service.alert.error(msg);
            return;
        }

        await this.loadCurrentFolder();
        await this.refreshTreeForCurrentFolder();

        if (this.isSearchMode) {
            await this.handleSearch();
        }

        this.selectedItems = new Set();
        await this.service.render();
    }

    public get canDragMoveItems(): boolean {
        if (this.isSearchMode) return false;
        if (this.isAdmin) {
            return true;
        }
        return !!this.community;
    }
}

export default PortalGsdcadminManualStorageComponent;